import { render, staticRenderFns } from "./OrderProductQuery.vue?vue&type=template&id=608cbdc5&scoped=true&"
import script from "./OrderProductQuery.vue?vue&type=script&lang=js&"
export * from "./OrderProductQuery.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductQuery.vue?vue&type=style&index=0&id=608cbdc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608cbdc5",
  null
  
)

export default component.exports